module.exports = __webpack_public_path__ + "static/media/hartwall-logo.36559505.svg";